import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { ImpactSummaryDto } from '../../../models/analytics/dto/get-impact-summary.dto';

export const GET_IMPACT_SUMMARY_QUERY_KEY = 'impactSummary';

export const useGetImpactSummary = (
    locationId: string | undefined,
    startDate?: Date,
    endDate?: Date,
) => {
    const apiClient = useApiClient();
    return useQuery<ImpactSummaryDto>({
        queryKey: [GET_IMPACT_SUMMARY_QUERY_KEY, locationId, startDate, endDate],
        queryFn: async () => {
            const dateSuffix =
                startDate && endDate
                    ? `&startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`
                    : '';
            return apiClient.fetchApi<ImpactSummaryDto, {}>({
                method: 'GET',
                endpoint: `analytics/impact-summary?locationId=${locationId}${dateSuffix}`,
            });
        },
        enabled: !!locationId,
        staleTime: 5 * 60 * 1000,
    });
};
